/* 의도적으로 비동기 효과 주는 함수 */
export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

/* 비밀번호 유효성 검사 */
export const passwordValidation = (value) => {
  const regex1 = /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!$@$!%*#?&])[A-Za-z0-9!$@$!%*#?&]{6,20}$/;
  const regex2 = /^(?!.*?(.)\1\1\1)/;

  if (!regex1.test(value)) {
    return "비밀번호는 알파벳, 숫자, 특수 문자를 포함하여 6~20자여야 합니다.";
  }
  if (!regex2.test(value)) {
    return "같은 문자는 4번 이상 반복될 수 없습니다.";
  }
  return true;
};
